module.exports = require("hkdf");